module.exports = __webpack_public_path__ + "img/impactful-icon.92073c1c.svg";